export const LOCAL_DELIVERY = 'https://otetsutabi.com/features/localdelivery';
